<div class="setup-container">
    
    <div class="loader-overlay" *ngIf="isGeneratingTest">
        <app-test-generation-loader></app-test-generation-loader>
    </div>

    
    <div class="header-row">
        <button mat-icon-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="header-text">
            <h1>{{ config.title }}</h1>
            <p>{{ config.description }}</p>
        </div>
    </div>

    
    <div class="setup-card" *ngIf="['aptitude', 'logical', 'verbal', 'programming'].includes(testType)">
        <div class="card-header">
            <h3>Enter Topics</h3>
            <span class="selected-count">{{ selectedTopics.length }} selected</span>
        </div>
        <div class="search-box">
            <mat-icon>search</mat-icon>
            <input type="text" placeholder="Type a topic and press Enter..." [(ngModel)]="topicInput"
                (keyup.enter)="addTopic()" maxlength="50">
        </div>
        <div class="selected-chips-row" *ngIf="selectedTopics.length > 0">
            <div class="chip" *ngFor="let topic of selectedTopics">
                {{ topic }}
                <mat-icon (click)="toggleTopic(topic)">close</mat-icon>
            </div>
        </div>
        <div class="suggested-topics">
            <h4>Suggested Topics</h4>
            <div class="topic-pills">
                <button *ngFor="let topic of config.suggestedTopics" class="pill-btn"
                    [class.active]="selectedTopics.includes(topic)" (click)="toggleTopic(topic)">
                    <span class="icon-span" *ngIf="selectedTopics.includes(topic)">✓</span>
                    <span class="icon-span" *ngIf="!selectedTopics.includes(topic)">+</span>
                    {{ topic }}
                </button>
            </div>
        </div>
    </div>

    
    <div class="setup-card" *ngIf="testType === 'company'">
        <div class="card-header">
            <h3>Company & Role Selection</h3>
        </div>
        <div class="dropdowns-row">
            
            <div class="custom-dropdown-container">
                <label>Company</label>
                <div class="dropdown-trigger" (click)="toggleCompanyDropdown($event)">
                    <span>{{ selectedCompany || 'Select company...' }}</span>
                    <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-menu" *ngIf="isCompanyDropdownOpen">
                    <div class="dropdown-search">
                        <mat-icon>search</mat-icon>
                        <input type="text" placeholder="Search companies..." [(ngModel)]="companySearch"
                            (click)="$event.stopPropagation()">
                    </div>
                    <div class="dropdown-list">
                        <div class="dropdown-item" *ngFor="let company of filteredCompanies"
                            (click)="selectCompany(company)">
                            {{ company }}
                        </div>
                        <div class="dropdown-item" *ngIf="filteredCompanies.length === 0">No companies found</div>
                    </div>
                </div>
            </div>

            
            <div class="custom-dropdown-container">
                <label>Role</label>
                <div class="dropdown-trigger" (click)="toggleRoleDropdown($event)">
                    <span>{{ selectedRole || 'Select role...' }}</span>
                    <mat-icon>expand_more</mat-icon>
                </div>
                <div class="dropdown-menu" *ngIf="isRoleDropdownOpen">
                    <div class="dropdown-search">
                        <mat-icon>search</mat-icon>
                        <input type="text" placeholder="Search roles..." [(ngModel)]="roleSearch"
                            (click)="$event.stopPropagation()">
                    </div>
                    <div class="dropdown-list">
                        <div class="dropdown-item" *ngFor="let role of filteredRoles" (click)="selectRole(role)">
                            {{ role }}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <div class="setup-card" *ngIf="testType === 'resume'">
        <div class="card-header">
            <h3>Resume Upload</h3>
        </div>

        
        <div class="upload-zone" *ngIf="!uploadedFileName">
            <div class="upload-dashed-border">
                <mat-icon>upload</mat-icon>
                <p><strong>Drop your resume here</strong></p>
                <span>PDF, DOCX, TXT supported (Max 5 MB)</span>
                <input type="file" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx,.txt">
            </div>
        </div>

        
        <div class="selected-file-container" *ngIf="uploadedFileName">
            <div class="file-row">
                <div class="file-info">
                    <mat-icon class="file-icon">description</mat-icon>
                    <span>{{ uploadedFileName }}</span>
                </div>
                <button mat-icon-button (click)="removeFile()" class="remove-btn">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        
        <div class="loading-state" *ngIf="isExtracting">
            <div class="spinner"></div> 
            <p>Extracting skills from resume...</p>
        </div>

        
        <div class="extracted-skills-container" *ngIf="extractedSkills.length > 0 && !isExtracting">
            <p class="section-label">Extracted skills:</p>
            <div class="skills-row">
                <div class="skill-chip" *ngFor="let skill of extractedSkills">
                    {{ skill }}
                    <mat-icon (click)="removeExtractedSkill(skill)">close</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div class="setup-card settings-card">
        <h3>Test Settings</h3>

        <div class="settings-grid">
            
            <div class="setting-group">
                <label>Difficulty</label>
                <div class="toggle-group">
                    <button class="toggle-btn" [class.active]="selectedDifficulty === 'Easy'"
                        (click)="selectedDifficulty = 'Easy'">Easy</button>
                    <button class="toggle-btn" [class.active]="selectedDifficulty === 'Medium'"
                        (click)="selectedDifficulty = 'Medium'">Medium</button>
                    <button class="toggle-btn" [class.active]="selectedDifficulty === 'Hard'"
                        (click)="selectedDifficulty = 'Hard'">Hard</button>
                </div>
            </div>
            <div class="setting-group">
                <label>Questions</label>
                <div class="toggle-group">
                    <button class="toggle-btn" [class.active]="selectedQuestions === 10"
                        (click)="selectedQuestions = 10">10</button>
                    <button class="toggle-btn" [class.active]="selectedQuestions === 20"
                        (click)="selectedQuestions = 20">20</button>
                    <button class="toggle-btn" [class.active]="selectedQuestions === 30"
                        (click)="selectedQuestions = 30">30</button>
                </div>
            </div>
        </div>
    </div>
    <div class="setup-footer">
        
        <div class="left-spacer"></div>

        <button mat-raised-button class="generate-btn" (click)="generateTest()"
			*hasPermission="PermissionForStudents.PLACEMENT_CREATE">
            <mat-icon>auto_awesome</mat-icon>
            Generate Test
        </button>
    </div>
	</div> 